
import { ThrowStmt } from '@angular/compiler';
import { SelectItem, Message } from 'primeng/primeng';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { of } from 'rxjs';
import { DistriCommandeService } from 'src/app/provider/distri/distri.commande.service';
import { DistriAuthService } from 'src/app/provider/distri/distri.auth.service';
import { DistriAgentService } from 'src/app/provider/distri/distri.agent.service';
import { DistriStoreService } from 'src/app/provider/distri/distri.store.service';
import { DistriClientsService } from 'src/app/provider/distri/distri.clients.service';
import { DistriExcelService } from 'src/app/provider/distri/distri.excel.service';
import { ConstService } from 'src/app/const.service';
import { saveAs } from 'file-saver/FileSaver'; 
import { ConfirmationService, MessageService } from 'primeng-lts/api';
import {  VenteApiService } from 'src/app/provider/stock/VenteApi.service';
import { FactureUpdateService } from 'src/app/provider/priseCommande/FactureUpdate.service';

@Component({
  selector: 'app-distri-list-commande',
  templateUrl: './distri-list-commande.component.html',
  styleUrls: ['./distri-list-commande.component.css']
})
export class DistriListCommandeComponent implements OnInit  {

  listZone: SelectItem[] = [];
  titre = 'Etat des commandes disributeurs';
  commandes: any[] = [];
  commandesDetails: any[] = [];
  msgs: Message[] = [];
  allCommandes: any[] = [];
  role: string;
  state = 'ENCOURS';
  dateFin: any = new Date();
  dateDebut: any = new Date();
  typeCommande: any;
  pdg: any;

  displayAllCommande : boolean = true;

  listeTypeCommande: SelectItem[] = [
    {
      label: 'Selectionner...', value: ''
    },
    {
      label: 'AIRTIME', value: 'Airtime'
    },
    {
      label: 'MOBILE MONEY', value: 'Mobile Money'
    },
    {
      label: 'PRODUIT', value: 'Produits'
    }];

  listePdg: SelectItem[] = [
    {
      label: 'Selectionner...', value: ''
    },
  ];


  listEtat: SelectItem[] = [
    {
      label: 'Selectionner...', value: ''
    },
    {
      label: 'ENCOURS', value: 'ENCOURS'
    },
    {
      label: 'VALIDE', value: 'VALIDE'
    }];

    listEtapes: SelectItem[] = [
      {
        label: 'Selectionner...', value: ''
      },
      {
        label: 'ADV', value: 'ADV'
      },
      {
        label: 'TRESORERIE', value: 'TRESORERIE'
      },
      {
        label: 'TRESORERIE_OMY', value: 'TRESORERIE_OMY'
      },
      {
        label: 'DAL', value: 'DAL'
      },
      {
        label: 'OPERATION', value: 'OPERATION'
      }];

  size = 5;
  totalElements: number;
  referenceCommande: any;
  zoneLivraison: any;
  etatLivraison: any;
  selectedEtape: any;
  displaychargement = false;
  droit : boolean = true;
  droitValidationCommande : boolean = true;
  droitEtatCommandes : boolean = true;
  isUserPartenaire = false;
  fr:any;
  constructor(
    private messageService: MessageService,
    private constService: ConstService, 
    private route: Router, 
    private venteApiService: VenteApiService,
    private factureUpdateService : FactureUpdateService,
    private commandeService: DistriCommandeService, 
    private store: DistriStoreService,
    public authService: DistriAuthService, 
    public agentService: DistriAgentService, 
    private clientsService:  DistriClientsService, 
    private excelService: DistriExcelService
  ) { }

  // En attente, encours, valide, rejete, neutre (non reçu)
  async ngOnInit() {

    // this.droit = this.constService.hasDroit("DS002") || this.constService.hasDroit("DS003");
    // this.droitEtatCommandes = this.constService.hasDroit("DS003");
    // this.droitValidationCommande = this.constService.hasDroit("DS002");
    // if(!this.droit) {
    //   this.route.navigateByUrl('/distri/acceuil');
    // }
   
    this.fr = this.constService.custumDateFr;
    this.role = this.constService.currentRoleDistri;
    this.isUserPartenaire =
      this.store.isUserPartenaire || this.constService.currentRoleDistri === 'PARTENAIRE';
    console.log("this.constService.currentRoleDistri==="+this.constService.currentRoleDistri);

    this.displayAllCommande = true;
    if(sessionStorage.getItem("DISPALAY_COMMANDES_DISTRI_ALL") !== "OK"){
      this.displayAllCommande = false;
      this.titre = 'Mes commandes à valider';
      this.selectedEtape = this.role;
      this.etatLivraison = 'ENCOURS';
    }
    
    await this.getListZone();
    await this.getListPdg();
    this.applyPartenaireScope();
    this.search();
  }

  applyPartenaireScope() {
    if (this.isUserPartenaire) {
      this.pdg = this.store.currentNomPDG;
    }
  }

  buildSearchCriteria() {
    this.applyPartenaireScope();
    return {
      typeCommande: this.typeCommande,
      dateDebut: this.constService.localeDateString(this.dateDebut),
      dateFin: this.constService.localeDateString(this.dateFin),
      pdg: this.isUserPartenaire ? this.store.currentNomPDG : this.pdg,
      statut: this.etatLivraison,
      etat : this.selectedEtape,
      referenceCommande: this.referenceCommande,
      zone: this.zoneLivraison,
    };
  }

  keepAllowedCommandes(commandes: any[]) {
    const pdg = this.pdg || (this.isUserPartenaire ? this.store.currentNomPDG : null);
    if (!pdg) {
      return commandes || [];
    }
    return (commandes || []).filter(commande => commande.login === pdg);
  }

  keepAllowedCommandeDetails(details: any[]) {
    const pdg = this.pdg || (this.isUserPartenaire ? this.store.currentNomPDG : null);
    if (!pdg) {
      return details || [];
    }
    return (details || []).filter(detail =>
      detail.commandeLite && detail.commandeLite.login === pdg
    );
  }

  async search() {
    this.displaychargement = true;
    const criteria = this.buildSearchCriteria();
    console.log('criteria: ', criteria);
    try {
      const commandes = <any>await this.commandeService.getCommandeByCriteria(criteria).toPromise();
      this.commandes = this.keepAllowedCommandes(commandes);
    } catch (error) {
      console.log("error",error);
      this.commandes = [];
    }
    console.log('commandes: ', this.commandes);
    this.displaychargement = false;
  }

  

  async getAllCommandes() {
    if (this.isUserPartenaire) {
      return this.getCommandeByLogin(this.store.currentNomPDG, 'HISTORIQUE');
    }
    this.displaychargement = true;
    this.state = 'HISTORIQUE';
    this.allCommandes = <any>await this.commandeService.commandes().toPromise();
    this.commandes = this.keepAllowedCommandes(this.allCommandes);
    this.displaychargement = false;
  }

  async getCommandeByRoleAndEtat(target: any, state: any) {
    if (this.isUserPartenaire) {
      return this.getCommandeByLogin(this.store.currentNomPDG, state);
    }
    this.displaychargement = true;
    this.state = state;
    try {
      this.allCommandes = <any>await this.commandeService.commandeByRoleAndEtat(target, state).toPromise();
      console.log('currenteUser:', this.authService.currentUser);
      console.log('this.allCommandes: ', this.allCommandes);
      console.log('this.constService.currentRoleDistri: ', this.constService.currentRoleDistri);
      if (this.constService.currentRoleDistri === 'MAGASIN_AGENT') {
        //this.allCommandes.forEach(e => { console.log('commande: ', e) });
        this.allCommandes = this.allCommandes.filter(e => e.zone === this.authService.currentUser.zone);
        console.log('End***********')

      }
      this.commandes = this.allCommandes;
      console.log('after***********', this.commandes)
    } catch (error) {

    } finally {
      this.displaychargement = false;
    }
  }

  async exporter() {
    if(this.commandes === null || this.commandes === undefined) {
      this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    if(this.commandes.length <= 0) {
      this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    let listExportXLSX = [];
    listExportXLSX = [...this.commandes.map(entry => ({
        "TYPE_COMMANDE": entry.typeCommande,
        "PARTENAIRE": entry.login,
        "REFERENCE COMMANDE": entry.referenceCommande,
        "REFERENCE ORACLE": entry.referenceOracle,
        "MONTANT": entry.montant,
        "DEVISE": entry.devise,
        //"TAUX_ECHANGE": entry.tauxEchange,
        "AGENT": entry.agent,
        "ETAT":entry.etatLivraison,
        "ETAPE":entry.etat,
        "FACTURE":entry.facture,
        "BANQUE":entry.banque,
        "REFERENCE_PAIEMENT":entry.bordereau,
        "DATE_COMMANDE": new Date(entry.dateCommande).toLocaleString()
      }))
    ];
    this.excelService.exportAsExcelFile(listExportXLSX, 'EXPORT');
    this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'info', summary: 'Confirmation', detail: 'Export effectuée, ' + this.commandes.length + ' Ligne(s) trouvée(s)' });
  }

  async exporterFinance() {
    if(this.commandes === null || this.commandes === undefined) {
      this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    if(this.commandes.length <= 0) {
      this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    let listExportXLSX = [];
    listExportXLSX = [...this.commandes.filter(val => val.typeCommande !== 'Mobile Money').map(entry => ({
        "TYPE_COMMANDE": entry.typeCommande,
        "PARTENAIRE": entry.login,
        "REFERENCE COMMANDE": entry.referenceCommande,
        "REFERENCE ORACLE": entry.referenceOracle,
        "MONTANT": entry.montant,
        "DEVISE": entry.devise,
        //"TAUX_ECHANGE": entry.tauxEchange,
        "AGENT": entry.agent,
        "ETAT":entry.etatLivraison,
        "ETAPE":entry.etat,
        "FACTURE":entry.facture,
        "BANQUE":entry.banque,
        "REFERENCE_PAIEMENT":entry.bordereau,
        "DATE_COMMANDE": new Date(entry.dateCommande).toLocaleString()
      }))
    ];
    this.excelService.exportAsExcelFile(listExportXLSX, 'EXPORT');
    this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'info', summary: 'Confirmation', detail: 'Export effectuée, ' + this.commandes.length + ' Ligne(s) trouvée(s)' });
  }


  async exporterDetails() {
    this.displaychargement = true;
    const criteria = this.buildSearchCriteria();
    console.log('criteria-detials DEBUTTT: ', criteria);
    try {
      const details = <any>await this.commandeService.getCommandeDetailsByCriteria(criteria).toPromise();
      this.commandesDetails = this.keepAllowedCommandeDetails(details);
    } catch (error) {
      console.log("error",error);
      this.commandesDetails = [];
      this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      this.displaychargement = false;
      return;
    }
    console.log('criteria-detials FINNNNN: ', criteria);
    console.log('this.commandesDetails: ', this.commandesDetails);

    if(this.commandesDetails === null || this.commandesDetails === undefined) {
      this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      this.displaychargement = false;
      return;
    }
    if(this.commandesDetails.length <= 0) {
      this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      this.displaychargement = false;
      return;
    }


    let listExportXLSX = [];
    listExportXLSX = [...this.commandesDetails.map(entry => ({
        
        "TYPE_COMMANDE": entry.commandeLite.typeCommande,
        "PARTENAIRE": entry.commandeLite.login,
        "REFERENCE COMMANDE": entry.commandeLite.referenceCommande,
        "REFERENCE ORACLE": entry.commandeLite.referenceOracle,
        "MONTANT TOTAL": entry.commandeLite.montant,
        "DEVISE": entry.commandeLite.devise,
        //"TAUX_ECHANGE": entry.commandeLite.tauxEchange,
        
        "TYPE_PRODUIT": entry.categorie,
        "PRODUIT": entry.libelle,
        "MSISDN": entry.msisdn,

        "MONTANT HT": entry.montantHt,
        "MONTANT TVA": entry.montantTva,
        "MONTANT TAXE ACCISE": entry.montantTaxe2,
        "MONTANT TTC": entry.montant,
        
        "QUANTITE": entry.quantite,
        "MONTANT_DEPOT": entry.montantDepot,
        //"TAUX_PUE": entry.pue,
        
        "AGENT": entry.commandeLite.agent,
        "ETAT":entry.commandeLite.etatLivraison,
        "ETAPE":entry.commandeLite.etat,
        "FACTURE":entry.commandeLite.facture,
        "TRANSFERT":entry.commandeLite.retourTransfert,
        "BANQUE":entry.commandeLite.banque,
        "REFERENCE_PAIEMENT":entry.commandeLite.bordereau,
        "DATE_COMMANDE": new Date(entry.commandeLite.dateCommande).toLocaleString()
      }))
    ];
    this.excelService.exportAsExcelFile(listExportXLSX, 'EXPORT');
    this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'info', summary: 'Confirmation', detail: 'Export effectuée, ' + this.commandesDetails.length + ' Ligne(s) trouvée(s)' });

    this.displaychargement = false;
  }


  async exporterDetailsFinance() {
    this.displaychargement = true;
    const criteria = this.buildSearchCriteria();
    console.log('criteria-detials DEBUTTT: ', criteria);
    try {
      const details = <any>await this.commandeService.getCommandeDetailsByCriteria(criteria).toPromise();
      this.commandesDetails = this.keepAllowedCommandeDetails(details);
    } catch (error) {
      console.log("error",error);
      this.commandesDetails = [];
      this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      this.displaychargement = false;
      return;
    }
    console.log('criteria-detials FINNNNN: ', criteria);
    console.log('this.commandesDetails: ', this.commandesDetails);

    if(this.commandesDetails === null || this.commandesDetails === undefined) {
      this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      this.displaychargement = false;
      return;
    }
    if(this.commandesDetails.length <= 0) {
      this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      this.displaychargement = false;
      return;
    }


    let listExportXLSX = [];
    listExportXLSX = [...this.commandesDetails.filter(val => val.commandeLite.typeCommande !== 'Mobile Money').map(entry => ({
        
        "TYPE_COMMANDE": entry.commandeLite.typeCommande,
        "PARTENAIRE": entry.commandeLite.login,
        "REFERENCE COMMANDE": entry.commandeLite.referenceCommande,
        "REFERENCE ORACLE": entry.commandeLite.referenceOracle,
        "MONTANT TOTAL": entry.commandeLite.montant,
        "DEVISE": entry.commandeLite.devise,
        //"TAUX_ECHANGE": entry.commandeLite.tauxEchange,
        
        "TYPE_PRODUIT": entry.categorie,
        "PRODUIT": entry.libelle,
        "MSISDN": entry.msisdn,

        "MONTANT HT": entry.montantHt,
        "MONTANT TVA": entry.montantTva,
        "MONTANT TAXE ACCISE": entry.montantTaxe2,
        "MONTANT TTC": entry.montant,
        
        "QUANTITE": entry.quantite,
        "MONTANT_DEPOT": entry.montantDepot,
        //"TAUX_PUE": entry.pue,
        
        "AGENT": entry.commandeLite.agent,
        "ETAT":entry.commandeLite.etatLivraison,
        "ETAPE":entry.commandeLite.etat,
        "FACTURE":entry.commandeLite.facture,
        "TRANSFERT":entry.commandeLite.retourTransfert,
        "BANQUE":entry.commandeLite.banque,
        "REFERENCE_PAIEMENT":entry.commandeLite.bordereau,
        "DATE_COMMANDE": new Date(entry.commandeLite.dateCommande).toLocaleString()
      }))
    ];
    this.excelService.exportAsExcelFile(listExportXLSX, 'EXPORT');
    this.messageService.clear(); this.messageService.add({ life: 15000, severity: 'info', summary: 'Confirmation', detail: 'Export effectuée, ' + this.commandesDetails.length + ' Ligne(s) trouvée(s)' });

    this.displaychargement = false;
  }


  async getCommandeByLogin(login: any, state?: any) {
    this.displaychargement = true;
    this.state = state;
    try {
      this.allCommandes = <any>await this.commandeService.commandeByLoginAndEtat(login, state).toPromise();
      this.commandes = this.keepAllowedCommandes(this.allCommandes);
    } catch (error) {

    } finally {
      this.displaychargement = false;
    }
  }

  async getOracle(reference: any) {
    this.displaychargement = true;
    try {
      this.commandes = []; //<any>await this.commandeService.getOracleData(reference).toPromise();
    } catch (error) {

    } finally {
      this.displaychargement = false;
    }
  }

  goToDetailCommande(commande: any) {
    this.store.tmp.commande = commande;
    //console.log("commande",commande);
    if (this.state === 'ENCOURS' && this.constService.currentRoleDistri !== 'PARTENAIRE') {
      this.route.navigateByUrl('/root/validate-commande-details?id=' + commande.id);
    } else {
      //this.route.navigateByUrl('/distri/details-commande?id=' + commande.id);
      this.route.navigateByUrl('/root/validate-commande-details?id=' + commande.id);
    }
  }

  getCommandes(role: any, state: any) {
    this.state = state;
    this.getCommandeByRoleAndEtat(role, state);
  }


  async getListPdg(){
    try {
      if(this.store.isUserPartenaire) {
        this.listePdg = [];
        this.listePdg.push({ label: this.store.currentNomPDG, value: this.store.currentNomPDG });
        this.pdg = this.store.currentNomPDG;
      } else {
        this.listePdg = [];
        this.listePdg.push({ label: 'Selectionner...', value: null });
        let dataRetourPdg = <any>await this.clientsService.findAgents().toPromise();
        for (let el of dataRetourPdg) {
          this.listePdg.push({ label: el.login + " - " + el.msisdn, value: el.login });
        }
      }
    } catch (error) { }
}

getTypeCommandeLogo(typeCommande) {
  return ({ 'Airtime': '/assets/dist/img/nafama_logo.svg', 'Produits': '/assets/dist/img/produitc_logo.svg', 'Mobile Money': '/assets/dist/img/orange_money.svg' })[typeCommande];
}

/*
ngAfterViewChecked() {
  console.log("! changement de la date du composant !");
}
*/

async getListZone() {
  console.log('getListZone: ', this.listZone);
  this.listZone = [
    { label: 'ZONE...', value: null },
    ...(await this.agentService.findAllZone().toPromise() as any).map(element => {
      return {
        label: element.nom, value: element.nom
      };
    })];
  console.log('listZone: ', this.listZone);
}

onChangeTypeCommande(event) {
  this.typeCommande = event.value;
  console.log('typeCommande: ', this.typeCommande);
}

onChangePdg(event) {
  if (this.isUserPartenaire) {
    this.applyPartenaireScope();
    return;
  }
  this.pdg = event.value;
  console.log('typeCommande: ', this.pdg);
}

printFactureIsolle(numFacture) { 
  if(numFacture !== null && numFacture !== undefined && numFacture !== "" ) {
      this.factureUpdateService.printFactureIsolle(numFacture).subscribe( (data: any) => {
          var blob = new Blob([data], { type: 'application/pdf'});
          saveAs(blob, 'facture.pdf' );
          var fileUrl = URL.createObjectURL(blob);
          //window.open(fileUrl);
      },  error => { console.log(error); this.messageService.clear(); this.messageService.add({life: 15000,severity:'info', summary:'Information', detail:'Pas de données trouvées !'}); }); 
  } else {
    this.messageService.clear(); this.messageService.add({life: 15000,severity:'info', summary:'Information', detail:'Pas de facture trouvée !'});
  }
}

regenererFacture(cmd) { 
  console.log("commande", cmd);
  if(cmd && cmd.facture) {
      this.displaychargement=true;
      const nomVendeur = cmd.nomPdg != null && cmd.nomPdg !== '' ? cmd.nomPdg : (cmd.login || '');
      const codeVendeur = cmd.agent || cmd.login || '';
      const numeroVendeurDistri = cmd.telephonePdg != null && cmd.telephonePdg !== '' ? cmd.telephonePdg : (cmd.msisdn || undefined);
      this.venteApiService.printFactureDistri(cmd.facture, nomVendeur, codeVendeur, numeroVendeurDistri).subscribe( (data: any) => {
        this.displaychargement=false;
        var blob = new Blob([data], { type: 'application/pdf'});
        saveAs(blob, 'facture.pdf' );
        var fileUrl = URL.createObjectURL(blob);
        //window.open(fileUrl);
        this.search();
      },  error => { this.displaychargement=false; console.log(error); this.messageService.clear(); this.messageService.add({life: 15000,severity:'info', summary:'Information', detail:'Une erreur est survenue !!!'}); }); 
  } else {
    this.displaychargement=false;
    this.messageService.clear(); this.messageService.add({life: 15000,severity:'info', summary:'Information', detail:'Pas de facture trouvée !'});
  }
}

regenererFactureNum(cmd) { 
  console.log("commande", cmd);
  if(cmd && cmd.etatLivraison==='VALIDE' && !cmd.facture) {
      this.displaychargement=true;
      this.commandeService.generateFacture(cmd.id).subscribe( (data: any) => {
        this.displaychargement=false;
        this.regenererFacture(data);
      }, error => { this.displaychargement=false; console.log(error); this.messageService.clear(); this.messageService.add({life: 15000,severity:'info', summary:'Information', detail:'Une erreur est survenue !!!'}); }); 
  } else {
    this.displaychargement=false;
    this.messageService.clear(); this.messageService.add({life: 15000,severity:'info', summary:'Information', detail:'Operation impossible !'});
  }
}

onHistoriqueCommande(){
  sessionStorage.setItem("DISPALAY_COMMANDES_DISTRI_ALL", "OK");
  if(sessionStorage.getItem("DISPALAY_COMMANDES_DISTRI_ALL") !== "OK"){
    this.displayAllCommande = false;
    this.titre = 'Mes commandes à valider';
    this.selectedEtape = this.role;
    this.etatLivraison = 'ENCOURS';
  } else {
    this.displayAllCommande = true;
    this.titre = 'Etats des commandes disributeurs';
    this.selectedEtape = "";
    this.etatLivraison = "";
  }
  this.applyPartenaireScope();
  this.search();
}
onValidateCommande(){
  sessionStorage.setItem("DISPALAY_COMMANDES_DISTRI_ALL", "ROLE");
  if(sessionStorage.getItem("DISPALAY_COMMANDES_DISTRI_ALL") !== "OK"){
    this.displayAllCommande = false;
    this.titre = 'Mes commandes à valider';
    this.selectedEtape = this.role;
    this.etatLivraison = 'ENCOURS';
  } else {
    this.displayAllCommande = true;
    this.titre = 'Etat des commandes disributeurs';
    this.selectedEtape = "";
    this.etatLivraison = "";
  }
  this.applyPartenaireScope();
  this.search();
}


}
